import React from 'react';
import { useTranslation } from 'react-i18next';
import { VrrButton, VrrCard } from '../../../shared_components';
import './Method.scss';

const Method: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="import-data-modal-method-container">
      <VrrCard
        className="import-data-modal-method-card"
        cardBody={{
          element: (
            <div className="import-data-modal-method">
              <h4>{t('import_data.import_data_modal.0.csv.title')}</h4>
              <p>{t('import_data.import_data_modal.0.csv.description')}</p>
              <p className="import-data-modal-warning">
                <i className="tim-icons icon-alert-circle-exc" />{' '}
                {t('import_data.import_data_modal.0.csv.warning')}
              </p>
            </div>
          )
        }}
        cardFooter={
          <div className="method-card-footer">
            <VrrButton>
              {t('import_data.import_data_modal.0.csv.button')}
            </VrrButton>
          </div>
        }
      />
      <VrrCard
        className="import-data-modal-method-card"
        cardBody={{
          element: (
            <div className="import-data-modal-method">
              <h4>{t('import_data.import_data_modal.0.platform.title')}</h4>
              <p>{t('import_data.import_data_modal.0.platform.description')}</p>
              <p className="import-data-modal-success">
                <i className="tim-icons icon-check-2" />{' '}
                {t('import_data.import_data_modal.0.platform.warning')}
              </p>
            </div>
          )
        }}
        cardFooter={
          <div className="method-card-footer">
            <VrrButton>
              {t('import_data.import_data_modal.0.platform.button')}
            </VrrButton>
          </div>
        }
      />
    </div>
  );
};

export default Method;
